import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";
import { useMemo } from "react";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * HeaderResumo
 */

type Props = {
  descricao: string;
  status: number;
  centroCustos: number[] | null;
  dataAberturaInicio: Date | null;
  dataAberturaFinal: Date | null;
  dataEncerramentoInicio: Date | null;
  dataEncerramentoFinal: Date | null;
  centroCustoDropdown: CentroCustoDropDown[];
  onDescricaoChange: (valor: string) => void;
  onStatusChange: (status: number) => void;
  onDataAberturaChange: (inicio: Date | null, final: Date | null) => void;
  onDataEncerramentoChange: (inicio: Date | null, final: Date | null) => void;
  onCentroCustosChange: (centroCustos: number[] | null) => void;
  onClearFilters: () => void;
};

export const HeaderResumo = ({
  descricao,
  status,
  centroCustos,
  dataAberturaInicio,
  dataAberturaFinal,
  dataEncerramentoInicio,
  dataEncerramentoFinal,
  centroCustoDropdown,
  onDescricaoChange,
  onStatusChange,
  onDataAberturaChange,
  onDataEncerramentoChange,
  onCentroCustosChange,
  onClearFilters,
}: Props) => {

  const statusOptions = useMemo(() => {
    return [
      {
        id: 2,
        label: 'Todos',
      },
      {
        id: 1,
        label: 'Ativos',
      }, {
        id: 0,
        label: 'Deletados',
      }
    ];
  }, [
  ]);

  const selectedCentroCusto = useMemo(() => {
    if (centroCustos === null) return [];
    return centroCustoDropdown.filter(x => centroCustos.some(y => y === x.id));
  }, [
    centroCustos,
    centroCustoDropdown,
  ]);

  return (
    <CascateList title='Filtros' defaultOpen={true}>
      <div className="w-full flex flex-col gap-4">
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
            <DefaultSelectInput
              name='status'
              label='Status itens do checklist'
              showSelectionLabel={false}
              options={statusOptions}
              value={status}
              onChangeValue={e => onStatusChange(Number(e))}
            />

            <DefaultMultiAutocomplete
              label='Centro de Custo'
              options={centroCustoDropdown}
              getOptionKey={x => x.id}
              getOptionLabel={x => x.title}
              value={selectedCentroCusto}
              onChange={x => onCentroCustosChange(x ? x.map(y => y.id) : null)}
            />

            <DefaultDateRangePickerInput
              label='Data Abertura'
              dataDe={dataAberturaInicio}
              dataAte={dataAberturaFinal}
              onChange={(de, ate) => onDataAberturaChange(de, ate)}
            />

            <DefaultDateRangePickerInput
              label='Data Encerramento'
              dataDe={dataEncerramentoInicio}
              dataAte={dataEncerramentoFinal}
              onChange={(de, ate) => onDataEncerramentoChange(de, ate)}
            />

            <DefaultInput
              name='descricao'
              label='Descrição'
              value={descricao}
              onChangeValue={onDescricaoChange}
            />
          </div>
        </div>

        <div className="w-full flex flex-col items-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}